@if (definition) {
  <div [ngClass]="definition.class | classRule: value">
    @for (child of definition.definitions; track child) {
      @if (definition.visible | booleanRule: value:true) {
        <div
          [ngClass]="child.class | classRule: value"
          >
          @if (child.type === 'group') {
            <soft-dynamic-group-value
              [value]="value"
              [definition]="$any(child)"
              [loading]="loading"
              >
            </soft-dynamic-group-value>
          } @else {
            @if (child.title) {
              <label
                class="soft-label"
                [ngClass]="(child.titleClass | classRule: value) || 'left'"
                >{{ child.title }}</label
                >
              }
              <soft-dynamic-value
                class="w-full"
                [definition]="child"
                [value]="value"
                [loading]="loading"
              ></soft-dynamic-value>
            }
          </div>
        }
      }
    </div>
  }
